import React from 'react';

import { BasicFormModalLayout } from 'modules/components/layer13';
import { SaveInstallationsForm } from 'modules/components/layer12';

export type SaveInstallationsModalProps = {
  id: string;
  isVisible: boolean;
  handleClose: () => void;
};

export const FC = (props: SaveInstallationsModalProps) => {

  return (
    <BasicFormModalLayout.FC
      id={props.id}
      title='Save installations'
      subTitle='Enter details in order to save them to the system.'
      handleClose={props.handleClose}
      isVisible={props.isVisible}
    >
      <SaveInstallationsForm.FC
        id={props.id}
        handleClose={props.handleClose}
      />
    </BasicFormModalLayout.FC>
  );

};
